import hubspot from 'hubspot';
import { StaticAppInfo } from './reporters/BaseReporter';

export function getStaticAppName(staticAppInfo?: StaticAppInfo): string {
  if (staticAppInfo?.staticAppName) {
    return staticAppInfo.staticAppName;
  }
  if (hubspot?.bender?.currentProject) {
    return hubspot.bender.currentProject;
  }
  return '';
}

export function getStaticAppVersion(staticAppInfo?: StaticAppInfo): string {
  if (staticAppInfo?.staticAppVersion) {
    return staticAppInfo.staticAppVersion;
  }
  if (hubspot?.bender?.currentProjectVersion) {
    return hubspot.bender.currentProjectVersion;
  }
  return '';
}
